/**
 * @generated SignedSource<<d582d8914b0ee0678161d60af5ae63d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssuesAndPullRequestsCount$data = {
  readonly issues: {
    readonly totalCount: number;
  };
  readonly pullRequests: {
    readonly totalCount: number;
  };
  readonly " $fragmentType": "IssuesAndPullRequestsCount";
};
export type IssuesAndPullRequestsCount$key = {
  readonly " $data"?: IssuesAndPullRequestsCount$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssuesAndPullRequestsCount">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "states",
    "value": "OPEN"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssuesAndPullRequestsCount",
  "selections": [
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "IssueConnection",
      "kind": "LinkedField",
      "name": "issues",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "issues(states:\"OPEN\")"
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "PullRequestConnection",
      "kind": "LinkedField",
      "name": "pullRequests",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "pullRequests(states:\"OPEN\")"
    }
  ],
  "type": "Label",
  "abstractKey": null
};
})();

(node as any).hash = "e751927d612dc93fdc40f4b870bfc708";

export default node;
